import { render, staticRenderFns } from "./Variant.vue?vue&type=template&id=460e8938&scoped=true&"
import script from "./Variant.vue?vue&type=script&lang=js&"
export * from "./Variant.vue?vue&type=script&lang=js&"
import style0 from "./Variant.vue?vue&type=style&index=0&id=460e8938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460e8938",
  null
  
)

export default component.exports